import { InputContainer, Label } from "./Inputs";

import CustomSelect from "react-select";
import { colors } from "../../assets/styles/parameters";

// 1. Extract styles to a single reusable object to keep code DRY and perfectly match BaseInputs
const customStyles = {
  control: (base, state) => ({
    ...base,
    // Mimic your other inputs: Gray background, subtle border, black border on focus
    border: state.isFocused
      ? `1px solid ${colors.black}`
      : `0.5px solid ${colors.gray400}`,
    boxShadow: "none",
    backgroundColor: state.isFocused ? colors.white : colors.gray200,
    borderRadius: "5px",
    minHeight: "45px",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
  }),
  container: (base) => ({ ...base, margin: 0 }),
  indicatorSeparator: () => ({ display: "none" }), // Removes the ugly default divider line
  menu: (base) => ({
    ...base,
    marginTop: "4px",
    zIndex: 1000,
    borderRadius: "5px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  }),
  menuList: (base) => ({ ...base, padding: 0 }),
  valueContainer: (base) => ({ ...base, padding: "0 12px" }),
  option: (base, { isFocused, isSelected }) => ({
    ...base,
    color: colors.black,
    backgroundColor: isSelected
      ? colors.gray300
      : isFocused
        ? colors.gray100
        : colors.white,
    padding: "10px 12px", // Restored padding for better click targets!
    cursor: "pointer",
    "&:active": { backgroundColor: colors.gray300 },
  }),
};

// Generic Select (For use outside of forms)
export const Select = ({
  name,
  options = [],
  value,
  onChange,
  className,
  placeholder,
  noOptionsMessage,
  ...otherProps
}) => {
  return (
    <CustomSelect
      {...otherProps}
      className={className}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      name={name}
      options={options}
      isSearchable={false}
      maxMenuHeight={200}
      noOptionsMessage={noOptionsMessage}
      styles={customStyles}
    />
  );
};

// 2. The React Final Form Wrapper
export const SelectFinalForm = ({
  input,
  meta, // Extract meta for validation tracking
  label,
  options,
  entity,
  ...otherProps
}) => {
  // CRITICAL BRIDGE: Find the react-select object that matches the React Final Form string value
  const selectedOption =
    options?.find((opt) => opt.value === input.value) || null;

  return (
    <InputContainer>
      {label && <Label text={label} entity={entity} />}

      <CustomSelect
        {...otherProps}
        name={input.name}
        options={options}
        value={selectedOption}
        // Extract just the string value to pass back to React Final Form state
        onChange={(option) => input.onChange(option ? option.value : "")}
        onBlur={input.onBlur} // Required for "touched" validation errors
        onFocus={input.onFocus}
        isSearchable={false}
        maxMenuHeight={200}
        styles={customStyles}
      />

      {/* Render Validation Errors */}
      {meta && meta.touched && meta.error && (
        <span style={{ color: "red", fontSize: "0.8rem", marginTop: "0.5rem" }}>
          {meta.error}
        </span>
      )}
    </InputContainer>
  );
};
